exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".be5nU{background-color:rgba(0,0,0,.2);border:1px solid #fff;border-radius:0;height:38px;font-size:12px;color:#fff}.be5nU+.be5nU{border-left:none}._2LM3h{margin-right:5px;font-size:14px}", ""]);

// exports
exports.locals = {
	"bottom-button": "be5nU",
	"bottomButton": "be5nU",
	"paid-icon": "_2LM3h",
	"paidIcon": "_2LM3h"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.styl
// module id = 2811
// module chunks = mobile/mobile